import { useMemo } from "react";
import { serverInfo, serverInfoAuth } from "../http/ServerAPI";
import { useAsyncData } from "./useAsyncData";

export const useServerDetails = (serverId, isAuth) => {
    const state = useAsyncData(
        () => isAuth ? serverInfoAuth(serverId) : serverInfo(serverId),
        {
            deps: [serverId, isAuth],
            initialData: null,
            errorMessage: "Ошибка загрузки сервера",
        }
    );

    const shopCategories = useMemo(() => {
        if (!state.data || !Array.isArray(state.data.shop_items)) return [];
        const categories = new Set();
        state.data.shop_items.forEach((item) => {
            if (item.category_name) categories.add(item.category_name);
        });
        return Array.from(categories);
    }, [state.data]);

    return { ...state, server: state.data, setServer: state.setData, shopCategories };
};
